import { throwKrakenErrorResponse } from "./throwKrakenErrorResponse"

export function assertWithErrorCode<T>(value: T, errorCode: string): asserts value {
    if (value === undefined || value === null || value === false) {
        throwKrakenErrorResponse({ errorCode })
    }
}
